var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9661 0.958014C14.2656 1.30745 14.2252 1.83354 13.8757 2.13305L8.04239 7.13305C7.73032 7.40055 7.26981 7.40055 6.95774 7.13305L1.12441 2.13305C0.774968 1.83354 0.7345 1.30745 1.03402 0.958014C1.33354 0.608576 1.85962 0.568108 2.20906 0.867626L7.50007 5.40278L12.7911 0.867627C13.1405 0.568108 13.6666 0.608576 13.9661 0.958014Z",
    fill: "#2C313A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE1IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjk2NjEgMC45NTgwMTRDMTQuMjY1NiAxLjMwNzQ1IDE0LjIyNTIgMS44MzM1NCAxMy44NzU3IDIuMTMzMDVMOC4wNDIzOSA3LjEzMzA1QzcuNzMwMzIgNy40MDA1NSA3LjI2OTgxIDcuNDAwNTUgNi45NTc3NCA3LjEzMzA1TDEuMTI0NDEgMi4xMzMwNUMwLjc3NDk2OCAxLjgzMzU0IDAuNzM0NSAxLjMwNzQ1IDEuMDM0MDIgMC45NTgwMTRDMS4zMzM1NCAwLjYwODU3NiAxLjg1OTYyIDAuNTY4MTA4IDIuMjA5MDYgMC44Njc2MjZMNy41MDAwNyA1LjQwMjc4TDEyLjc5MTEgMC44Njc2MjdDMTMuMTQwNSAwLjU2ODEwOCAxMy42NjY2IDAuNjA4NTc2IDEzLjk2NjEgMC45NTgwMTRaIiBmaWxsPSIjMkMzMTNBIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };